/**
 * Friction Log Mapper
 *
 * Pure conversion functions between UI types (FrictionLogContext)
 * and Supabase DB row shapes (friction_log_entries table).
 */

import type { FrictionEntry, FrictionType, FrictionSeverity, FrictionStatus } from "@/data/frictionLogTypes";

// ── DB row shape ──────────────────────────────────────────────────────────────

export interface FrictionEntryRow {
  id: string;
  user_id: string;
  user_role: string;
  module_name: string;
  screen_name: string | null;
  job_id: string | null;
  friction_type: string;
  description: string;
  severity: string;
  status: string;
  admin_notes: string | null;
  created_at: string;
}

// ── Mappers ───────────────────────────────────────────────────────────────────

export function toDbEntry(entry: FrictionEntry): FrictionEntryRow {
  return {
    id: entry.id,
    user_id: entry.userId,
    user_role: entry.userRole,
    module_name: entry.moduleName,
    screen_name: entry.screenName ?? null,
    job_id: entry.jobId ?? null,
    friction_type: entry.frictionType,
    description: entry.description,
    severity: entry.severity,
    status: entry.status,
    admin_notes: entry.adminNotes ?? null,
    created_at: entry.createdAt,
  };
}

export function toUiEntry(row: FrictionEntryRow): FrictionEntry {
  return {
    id: row.id,
    userId: row.user_id,
    userRole: row.user_role,
    moduleName: row.module_name,
    screenName: row.screen_name ?? undefined,
    jobId: row.job_id ?? undefined,
    frictionType: row.friction_type as FrictionType,
    description: row.description,
    severity: row.severity as FrictionSeverity,
    status: row.status as FrictionStatus,
    adminNotes: row.admin_notes ?? undefined,
    createdAt: row.created_at,
  };
}
